import {
    Col, Input, PageHeader, Row,
    Space,
} from 'antd';
import { useEffect, useState } from 'react';
import { allProviders } from '../api/deliveryProviders';
import { DeliveryProvidersTable } from '../components/DeliveryProviders/DeliveryProvidersTable';
import { OctopusPaginatorQuery } from '../types/paginator';

import { DeliveryType } from '../types/delivery';
import { DeactivateDeliveryProvider } from '../components/Modals/DeliveryProviderModal/DeactivateDeliveryProvider';
import { ChangeTierDeliveryProviderModal } from '../components/Modals/DeliveryProviderModal';

const { Search } = Input;

export const DeliveryProvidersAll = () => {
    const [deliveryProvider, setDeliveryProvider] = useState<DeliveryType[]>([]);
    const [loading, setLoading] = useState(false);
    const [paginator, setPaginator] = useState<OctopusPaginatorQuery>({ limit: 10, page: 1 });
    const [total, setTotal] = useState(0);
    const [search, setSearch] = useState('');
    const [reload, setReload] = useState(false);

    useEffect(() => {
        setLoading(true);
        allProviders(paginator, search)
            .then(({ data }) => {
                setDeliveryProvider(data.data);
                setTotal(data.meta.itemCount);
            })
            .catch()
            .finally(() => setLoading(false));
    }, [paginator, search, reload]);

    return (
        <PageHeader
            title="Delivery Providers"
            style={{ padding: 0, marginTop: 24 }}
            footer={(
                <Space size={24} direction="vertical" style={{ width: '100%' }}>
                    <Row justify="start" gutter={16}>
                        <Col span={8}>
                            <Search
                                placeholder="Search..."
                                onSearch={(e: any) => {
                                    setPaginator(paginator);
                                    setSearch(e);
                                }}
                                allowClear
                                enterButton
                            />
                        </Col>
                    </Row>
                    <DeliveryProvidersTable
                        deliveryProvider={deliveryProvider}
                        loading={loading}
                        paginator={paginator}
                        setPaginator={setPaginator}
                        total={total}
                    />
                    <DeactivateDeliveryProvider setReload={setReload} />
                    <ChangeTierDeliveryProviderModal setReload={setReload} reload={reload} />
                </Space>
            )}
        />

    );
};
